var items = {
  "block.minecraft.air": "arja",
  "block.minecraft.stone": "ġebel",
  "block.minecraft.granite": "granit",
  "block.minecraft.polished_granite": "granit illustrat",
  "block.minecraft.diorite": "diorite",
  "block.minecraft.polished_diorite": "diorite illustrat",
  "block.minecraft.andesite": "andesite",
  "block.minecraft.polished_andesite": "andesite illustrat",
  "block.minecraft.grass_block": "blokka tal-ħaxix",
  "block.minecraft.dirt": "ħamrija",
  "block.minecraft.coarse_dirt": "ħamrija ħoxna",
  "block.minecraft.podzol": "podzol",
  "block.minecraft.crimson_nylium": "njlium krimżi",
  "block.minecraft.warped_nylium": "njlium stramb",
  "block.minecraft.cobblestone": "ġebel imfarrak",
  "block.minecraft.oak_planks": "planks tal-ballut",
  "block.minecraft.spruce_planks": "planks ta ' l-g ħażil",
  "block.minecraft.birch_planks": "planks tal-betbiena",
  "block.minecraft.jungle_planks": "planks tal-ġungla",
  "block.minecraft.acacia_planks": "planks tal-aka ċja",
  "block.minecraft.dark_oak_planks": "planelli tal-ballut skuri",
  "block.minecraft.crimson_planks": "planki krimżi",
  "block.minecraft.warped_planks": "planki strambi",
  "block.minecraft.oak_sapling": "żgħar tal-ballut",
  "block.minecraft.spruce_sapling": "żgħar tal-arżnu",
  "block.minecraft.birch_sapling": "żgħar tal-betula",
  "block.minecraft.jungle_sapling": "żgħar tal-ġungla",
  "block.minecraft.acacia_sapling": "żgħar tal-akaċja",
  "block.minecraft.dark_oak_sapling": "żġħar tal-ballut skur",
  "block.minecraft.bedrock": "blat",
  "block.minecraft.sand": "ramel",
  "block.minecraft.red_sand": "ramel aħmar",
  "block.minecraft.gravel": "żrar",
  "block.minecraft.gold_ore": "sigħat tad-deheb",
  "block.minecraft.iron_ore": "sigħat tal-ħadid",
  "block.minecraft.coal_ore": "sigħat tal-faħam",
  "block.minecraft.nether_gold_ore": "ore tad-deheb nether",
  "block.minecraft.oak_log": "ġurnal tal-ballut",
  "block.minecraft.spruce_log": "reġistru tal-ispruce",
  "block.minecraft.birch_log": "zokk tal-betbiena",
  "block.minecraft.jungle_log": "ġurnal tal-ġungla",
  "block.minecraft.acacia_log": "ġurnal ta ' l-aka ċja",
  "block.minecraft.dark_oak_log": "zokk skur tal-ballut",
  "block.minecraft.crimson_stem": "zokk krimżi",
  "block.minecraft.warped_stem": "zokk stramb",
  "block.minecraft.stripped_oak_log": "zokk imqaxxar tal-ballut",
  "block.minecraft.stripped_spruce_log": "zokk imqaxxar",
  "block.minecraft.stripped_birch_log": "reġistru tal-betbiena mneżża",
  "block.minecraft.stripped_jungle_log": "ġurnal tal-ġungla imqaxxar",
  "block.minecraft.stripped_acacia_log": "ir-re ġistru tal-aka ċja mqaxxar",
  "block.minecraft.stripped_dark_oak_log": "zokk tal-ballut skur imqaxxar",
  "block.minecraft.stripped_crimson_stem": "zokk krimżi imqaxxar",
  "block.minecraft.stripped_warped_stem": "zokk stramb imqaxxar",
  "block.minecraft.stripped_oak_wood": "injam tal-ballut imqaxxar",
  "block.minecraft.stripped_spruce_wood": "injam imqaxxar (spruce)",
  "block.minecraft.stripped_birch_wood": "injam tal-betula imqaxxar",
  "block.minecraft.stripped_jungle_wood": "injam imqaxxar jungla",
  "block.minecraft.stripped_acacia_wood": "injam imqaxxar tal-aka ċja",
  "block.minecraft.stripped_dark_oak_wood": "injam tal-ballut skur imqaxxar",
  "block.minecraft.stripped_crimson_hyphae": "ħajfi krimżi imqaxxar",
  "block.minecraft.stripped_warped_hyphae": "ħajfi stramb imqaxxar",
  "block.minecraft.oak_wood": "injam tal-ballut",
  "block.minecraft.spruce_wood": "injam tal-arżnu",
  "block.minecraft.birch_wood": "injam tal-betula",
  "block.minecraft.jungle_wood": "injam tal-ġungla",
  "block.minecraft.acacia_wood": "injam tal-akaċja",
  "block.minecraft.dark_oak_wood": "injam tal-ballut skur",
  "block.minecraft.crimson_hyphae": "ħajfi krimżi",
  "block.minecraft.warped_hyphae": "ħajfi stramb",
  "block.minecraft.oak_leaves": "weraq tal-ballut",
  "block.minecraft.spruce_leaves": "weraq tal-arżnu",
  "block.minecraft.birch_leaves": "weraq tal-betula",
  "block.minecraft.jungle_leaves": "weraq tal-ġungla",
  "block.minecraft.acacia_leaves": "weraq tal-akaċja",
  "block.minecraft.dark_oak_leaves": "wearaq tal-ballut skur",
  "block.minecraft.sponge": "sponża",
  "block.minecraft.wet_sponge": "sponża mxarba",
  "block.minecraft.glass": "ħġieġ",
  "block.minecraft.lapis_ore": "sigħat tal-lapis lazuli",
  "block.minecraft.lapis_block": "blokka tal-lapis lazuli",
  "block.minecraft.dispenser": "dispensur",
  "block.minecraft.sandstone": "ġebel tal-franka",
  "block.minecraft.chiseled_sandstone": "ġebel tal-franka mnaqqax",
  "block.minecraft.cut_sandstone": "ġebel imrammel",
  "block.minecraft.note_block": "blokka tal-mużika",
  "block.minecraft.powered_rail": "linji mixgħulin",
  "block.minecraft.detector_rail": "linji didekters",
  "block.minecraft.sticky_piston": "pistun iweħħel",
  "block.minecraft.cobweb": "għanqbuta",
  "block.minecraft.grass": "ħaxix",
  "block.minecraft.fern": "xitla",
  "block.minecraft.dead_bush": "xitla niexfa",
  "block.minecraft.seagrass": "ħaxix tal-ba ħar",
  "block.minecraft.sea_pickle": "pickle tal-ba ħar",
  "block.minecraft.piston": "pistun",
  "block.minecraft.white_wool": "suf abjad",
  "block.minecraft.orange_wool": "suf oranġjo",
  "block.minecraft.magenta_wool": "suf vjola ċar",
  "block.minecraft.light_blue_wool": "suf blu ċar",
  "block.minecraft.yellow_wool": "suf isfar",
  "block.minecraft.lime_wool": "suf aħdar ċar",
  "block.minecraft.pink_wool": "suf roża",
  "block.minecraft.gray_wool": "suf griż",
  "block.minecraft.light_gray_wool": "suf griż ċar",
  "block.minecraft.cyan_wool": "suf blu fl-aħdar",
  "block.minecraft.purple_wool": "suf vjola",
  "block.minecraft.blue_wool": "suf blu",
  "block.minecraft.brown_wool": "suf kannella",
  "block.minecraft.green_wool": "suf aħdar",
  "block.minecraft.red_wool": "suf aħmar",
  "block.minecraft.black_wool": "suf iswed",
  "block.minecraft.dandelion": "lelluxa",
  "block.minecraft.poppy": "peprina",
  "block.minecraft.blue_orchid": "orkidea blu",
  "block.minecraft.allium": "allium",
  "block.minecraft.azure_bluet": "azure bluet",
  "block.minecraft.red_tulip": "tulip ħamra",
  "block.minecraft.orange_tulip": "tulip oranġjo",
  "block.minecraft.white_tulip": "tulip bajda",
  "block.minecraft.pink_tulip": "tulip roża",
  "block.minecraft.oxeye_daisy": "narċisa",
  "block.minecraft.cornflower": "fjura tal-qam ħirrun",
  "block.minecraft.lily_of_the_valley": "lily tal-wied",
  "block.minecraft.wither_rose": "wither rose",
  "block.minecraft.brown_mushroom": "faqqiegħ kannella",
  "block.minecraft.red_mushroom": "faqqiegħ aħmar",
  "block.minecraft.crimson_fungus": "fungi krimżi",
  "block.minecraft.warped_fungus": "fungi stramb",
  "block.minecraft.crimson_roots": "għeruq krimżi",
  "block.minecraft.warped_roots": "għeruq stramb",
  "block.minecraft.nether_sprouts": "nebbieta tan-nether",
  "block.minecraft.weeping_vines": "dwieli tal-biki",
  "block.minecraft.twisting_vines": "dwieli li jduru",
  "block.minecraft.sugar_cane": "kannamieli zokkor",
  "block.minecraft.kelp": "kelp",
  "block.minecraft.bamboo": "bambù",
  "block.minecraft.gold_block": "blokka tad-deheb",
  "block.minecraft.iron_block": "blokka tal-ħadid",
  "block.minecraft.oak_slab": "blokka tal-ballut",
  "block.minecraft.spruce_slab": "blokka ta ' l-ispruce",
  "block.minecraft.birch_slab": "blokka tal-betula",
  "block.minecraft.jungle_slab": "blokka tal-ġungla",
  "block.minecraft.acacia_slab": "blokka tal-aka ċja",
  "block.minecraft.dark_oak_slab": "blokka tal-ballut skura",
  "block.minecraft.crimson_slab": "krimżi blata",
  "block.minecraft.warped_slab": "nofs planki strambi",
  "block.minecraft.stone_slab": "ċangun tal-ġebel",
  "block.minecraft.smooth_stone_slab": "blokka tal-ġebel lixxa",
  "block.minecraft.sandstone_slab": "ċangun tal-franka",
  "block.minecraft.cut_sandstone_slab": "qatgħa xkatstone",
  "block.minecraft.petrified_oak_slab": "blokka tal-ballut petrifikata",
  "block.minecraft.cobblestone_slab": "ċangun tal-ġebel imfarrak",
  "block.minecraft.brick_slab": "blokka tal-briks",
  "block.minecraft.stone_brick_slab": "blokka tal-briks tal-ġebel",
  "block.minecraft.nether_brick_slab": "ċangun tal-briks tan-nether",
  "block.minecraft.quartz_slab": "ċangun tal-kwarz",
  "block.minecraft.red_sandstone_slab": "ċangun tal-ġebel aħmar tal-franka",
  "block.minecraft.cut_red_sandstone_slab": "qatgħa ħamra tal-ġebla ramlija",
  "block.minecraft.purpur_slab": "ċangun tal-purpur",
  "block.minecraft.prismarine_slab": "blokka priismarine",
  "block.minecraft.prismarine_brick_slab": "blokka tal-briks tal-ba ħar",
  "block.minecraft.dark_prismarine_slab": "blokki tal-ba ħar prisskur",
  "block.minecraft.smooth_quartz": "blokka tal-kwarz lixxa",
  "block.minecraft.smooth_red_sandstone": "ġebel aħmar tal-franka lixx",
  "block.minecraft.smooth_sandstone": "ġebel tal-franka lixx",
  "block.minecraft.smooth_stone": "ġebla lixxa",
  "block.minecraft.bricks": "briks",
  "block.minecraft.tnt": "splussivi",
  "block.minecraft.bookshelf": "xkafef",
  "block.minecraft.mossy_cobblestone": "il-mossija cobblestone",
  "block.minecraft.obsidian": "ossidnu",
  "block.minecraft.torch": "torċa",
  "block.minecraft.end_rod": "virga tal-ender",
  "block.minecraft.chorus_plant": "xitla tal-chorus",
  "block.minecraft.chorus_flower": "fjura tal-chorus",
  "block.minecraft.purpur_block": "blokka tal-purpur",
  "block.minecraft.purpur_pillar": "pilastru tal-purpur",
  "block.minecraft.purpur_stairs": "taraġ tal-purpur",
  "block.minecraft.spawner": "qed jaqla '",
  "block.minecraft.oak_stairs": "turġien tal-ballut",
  "block.minecraft.chest": "senduq",
  "block.minecraft.diamond_ore": "sigħat tad-djamant",
  "block.minecraft.diamond_block": "blokka tad-djamant",
  "block.minecraft.crafting_table": "mejda tas-snajja",
  "block.minecraft.farmland": "art tar-raba",
  "block.minecraft.furnace": "forn",
  "block.minecraft.ladder": "sellum",
  "block.minecraft.rail": "linji tat-trakk",
  "block.minecraft.cobblestone_stairs": "taraġ tal-ġebel",
  "block.minecraft.lever": "swiċċ",
  "block.minecraft.stone_pressure_plate": "pjanċa tal-ġebel",
  "block.minecraft.oak_pressure_plate": "pjanċa tal-pressjoni tal-ballut",
  "block.minecraft.spruce_pressure_plate": "pjanċa tal-pressjoni spruce",
  "block.minecraft.birch_pressure_plate": "pjanċa tal-pressjoni tal-birch",
  "block.minecraft.jungle_pressure_plate": "pjanċa tal-pressjoni ġungla",
  "block.minecraft.acacia_pressure_plate": "pjanċa tal-pressjoni tal-aka ċja",
  "block.minecraft.dark_oak_pressure_plate": "pjanċa tal-pressjoni tal-ballut skura",
  "block.minecraft.crimson_pressure_plate": "pjanċa tal-pressjoni krimżi",
  "block.minecraft.warped_pressure_plate": "pjanċa tal-pressjoni stramb",
  "block.minecraft.polished_blackstone_pressure_plate": "pjanċa tal-pressjoni tal-ġebla sewda illostrata",
  "block.minecraft.redstone_ore": "sigħat tar-redstone",
  "block.minecraft.redstone_torch": "torċa tar-redstone",
  "block.minecraft.snow": "borra",
  "block.minecraft.ice": "silġ",
  "block.minecraft.snow_block": "blokka tas-sil ġ",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "tafal",
  "block.minecraft.jukebox": "jukebox",
  "block.minecraft.oak_fence": "ċint tal-ballut",
  "block.minecraft.spruce_fence": "ċint tal-arżnu",
  "block.minecraft.birch_fence": "ċint tal-betula",
  "block.minecraft.jungle_fence": "ċint tal-injam tal-ġungla",
  "block.minecraft.acacia_fence": "ċint tal-akaċja",
  "block.minecraft.dark_oak_fence": "ċint tal-ballut skur",
  "block.minecraft.crimson_fence": "ċint krimżi",
  "block.minecraft.warped_fence": "ċint stramb",
  "block.minecraft.pumpkin": "qargħa ħamra",
  "block.minecraft.carved_pumpkin": "qara ' ħamra",
  "block.minecraft.netherrack": "ġebel tan-nether",
  "block.minecraft.soul_sand": "trab tal-erwieħ",
  "block.minecraft.soul_soil": "ħamrija tar-ruħ",
  "block.minecraft.basalt": "bażalt",
  "block.minecraft.polished_basalt": "bażalt illostrat",
  "block.minecraft.soul_torch": "ruħ torċa",
  "block.minecraft.glowstone": "ġebel jixgħel",
  "block.minecraft.jack_o_lantern": "qargħa ħamra tixgħel",
  "block.minecraft.oak_trapdoor": "trapbieba tal-ballut",
  "block.minecraft.spruce_trapdoor": "trapbieb ta ' l-ispruce",
  "block.minecraft.birch_trapdoor": "traplbieba tal-betula",
  "block.minecraft.jungle_trapdoor": "jungla trapbieb",
  "block.minecraft.acacia_trapdoor": "it-trapbieb tal-aka ċja",
  "block.minecraft.dark_oak_trapdoor": "trapbieb skur tal-ballut",
  "block.minecraft.crimson_trapdoor": "bieba krimżi",
  "block.minecraft.warped_trapdoor": "bieba stramba",
  "block.minecraft.infested_stone": "ġebel infestat",
  "block.minecraft.infested_cobblestone": "il-cobblestone infestati",
  "block.minecraft.infested_stone_bricks": "briks tal-ġebel infestati",
  "block.minecraft.infested_mossy_stone_bricks": "briks tal-ġebel tal-mossija infestati",
  "block.minecraft.infested_cracked_stone_bricks": "briks tal-ġebel ikkrekkjati bis-s ħana",
  "block.minecraft.infested_chiseled_stone_bricks": "briks tal-ġebel chismejjel",
  "block.minecraft.stone_bricks": "briks tal-ġebel",
  "block.minecraft.mossy_stone_bricks": "briks tal-ġebel bil-moffa",
  "block.minecraft.cracked_stone_bricks": "briks tal-ġebel imxaqqaq",
  "block.minecraft.chiseled_stone_bricks": "briks tal-ġebel imnaqqax",
  "block.minecraft.brown_mushroom_block": "blokka tal-faqqieg ħ kannella",
  "block.minecraft.red_mushroom_block": "blokk tal-faqqieg ħ aħmar",
  "block.minecraft.mushroom_stem": "zokk tal-faqqieg ħ",
  "block.minecraft.iron_bars": "vireg tal-ħadid",
  "block.minecraft.chain": "katina",
  "block.minecraft.glass_pane": "ħġieġa ċatta",
  "block.minecraft.melon": "dulliegħa",
  "block.minecraft.vine": "dwieli",
  "block.minecraft.oak_fence_gate": "grada tal-ballut",
  "block.minecraft.spruce_fence_gate": "grada tal-arżnu",
  "block.minecraft.birch_fence_gate": "grada tal-betula",
  "block.minecraft.jungle_fence_gate": "grada tal-injam tal-ġungla",
  "block.minecraft.acacia_fence_gate": "grada tal-akaċja",
  "block.minecraft.dark_oak_fence_gate": "grada tal-ballut skur",
  "block.minecraft.crimson_fence_gate": "grada krimżi",
  "block.minecraft.warped_fence_gate": "grada stramba",
  "block.minecraft.brick_stairs": "taraġ tal-briks",
  "block.minecraft.stone_brick_stairs": "taraġ tal-briks tal-ġebel",
  "block.minecraft.mycelium": "moffa",
  "block.minecraft.lily_pad": "pjanta tal-ilma",
  "block.minecraft.nether_bricks": "briks nether",
  "block.minecraft.cracked_nether_bricks": "briks tan-nether bil-konsenturi",
  "block.minecraft.chiseled_nether_bricks": "briks tan-nether bid-disinn",
  "block.minecraft.nether_brick_fence": "ċint tan-nether",
  "block.minecraft.nether_brick_stairs": "taraġ tan-nether",
  "block.minecraft.enchanting_table": "tabella ta ' l-enchanting",
  "block.minecraft.end_portal_frame": "temm il-frejm tal-portal",
  "block.minecraft.end_stone": "ġebel tal-ender",
  "block.minecraft.end_stone_bricks": "briks tal-ġebel tal-ender",
  "block.minecraft.dragon_egg": "bajda ta' dragun",
  "block.minecraft.redstone_lamp": "lampa tar-redstone",
  "block.minecraft.sandstone_stairs": "taraġ tal-franka",
  "block.minecraft.emerald_ore": "sigħat tal-iżmerald",
  "block.minecraft.ender_chest": "senduq tal-ender",
  "block.minecraft.tripwire_hook": "ganċ tat-trappola",
  "block.minecraft.emerald_block": "blokka tal-iżmerald",
  "block.minecraft.spruce_stairs": "turġien fuq spruce",
  "block.minecraft.birch_stairs": "turġien tal-betula",
  "block.minecraft.jungle_stairs": "turġien tal-ġungla",
  "block.minecraft.crimson_stairs": "taraġ krimżi",
  "block.minecraft.warped_stairs": "taraġ stramb",
  "block.minecraft.command_block": "blokka tal-kodiċi",
  "block.minecraft.beacon": "lanterna",
  "block.minecraft.cobblestone_wall": "ħajt tas-sejjieħ",
  "block.minecraft.mossy_cobblestone_wall": "ħajt tas-sejjieħ bil-moffa",
  "block.minecraft.brick_wall": "ħajt tal-briks",
  "block.minecraft.prismarine_wall": "ħajt tal-ba ħar prismarine",
  "block.minecraft.red_sandstone_wall": "ħajt tad-sandstone aħmar",
  "block.minecraft.mossy_stone_brick_wall": "ħajt tal-briks tal-ġebel tal-g ħadma",
  "block.minecraft.granite_wall": "ħajt tal-granit",
  "block.minecraft.stone_brick_wall": "ħajt tal-briks tal-ġebel",
  "block.minecraft.nether_brick_wall": "ħajt tal-briks nether",
  "block.minecraft.andesite_wall": "ħajt estint",
  "block.minecraft.red_nether_brick_wall": "ħajt tal-briks tan-neputi aħmar",
  "block.minecraft.sandstone_wall": "ħajt tal-ġebla ramlija",
  "block.minecraft.end_stone_brick_wall": "tarf tal-ħajt tal-briks tal-ġebel",
  "block.minecraft.diorite_wall": "ħajt tad-diorite",
  "block.minecraft.blackstone_wall": "ħajt tal-ġebla sewda",
  "block.minecraft.polished_blackstone_wall": "ħajt tal-ġebla sewda illostrata",
  "block.minecraft.polished_blackstone_brick_wall": "ħajt tal-briks tal-ġebel sewda illostrata",
  "block.minecraft.stone_button": "buttuna tal-ġebel",
  "block.minecraft.oak_button": "buttuna tal-ballut",
  "block.minecraft.spruce_button": "buttuna ta ' spruce",
  "block.minecraft.birch_button": "buttuna tal-betula",
  "block.minecraft.jungle_button": "buttuna tal-ġungla",
  "block.minecraft.acacia_button": "buttuna tal-aka ċja",
  "block.minecraft.dark_oak_button": "buttuna tal-ballut skura",
  "block.minecraft.crimson_button": "buttuna krimżi",
  "block.minecraft.warped_button": "buttuna stramba",
  "block.minecraft.polished_blackstone_button": "buttuna tal-ġebla sewda illostrata",
  "block.minecraft.anvil": "inkwina",
  "block.minecraft.chipped_anvil": "imqatta ' bċejjeċ tal-art",
  "block.minecraft.damaged_anvil": "anvil bil-ħsara",
  "block.minecraft.trapped_chest": "senduq trappola",
  "block.minecraft.light_weighted_pressure_plate": "pjanċa tal-pressjoni peżata ħafifa",
  "block.minecraft.heavy_weighted_pressure_plate": "pjanċa tal-pressjoni ppeżata ħafna",
  "block.minecraft.daylight_detector": "ditekter tad-dawl tax-xemx",
  "block.minecraft.redstone_block": "blokka tar-redstone",
  "block.minecraft.nether_quartz_ore": "sigħat tal-kwartz tan-nether",
  "block.minecraft.hopper": "lembut",
  "block.minecraft.chiseled_quartz_block": "blokka tal-kwarz imnaqqxa",
  "block.minecraft.quartz_block": "blokka tal-kwarz",
  "block.minecraft.quartz_bricks": "briks tal-kwarz",
  "block.minecraft.quartz_pillar": "pilastru tal-kwarz",
  "block.minecraft.quartz_stairs": "taraġ tal-kwarz",
  "block.minecraft.activator_rail": "linji jattivaw",
  "block.minecraft.dropper": "qattara",
  "block.minecraft.white_terracotta": "abjad terracotta",
  "block.minecraft.orange_terracotta": "oranġjo terracotta",
  "block.minecraft.magenta_terracotta": "magenta terracotta",
  "block.minecraft.light_blue_terracotta": "light blue terracotta",
  "block.minecraft.yellow_terracotta": "isfar terracotta",
  "block.minecraft.lime_terracotta": "terracotta tal-ġir",
  "block.minecraft.pink_terracotta": "terracotta roża",
  "block.minecraft.gray_terracotta": "terrakotta griż",
  "block.minecraft.light_gray_terracotta": "terrakotta griża ċara",
  "block.minecraft.cyan_terracotta": "terrakotta cyan",
  "block.minecraft.purple_terracotta": "terrakotta vjola",
  "block.minecraft.blue_terracotta": "terrakotta ikħal",
  "block.minecraft.brown_terracotta": "terrakotta kannella",
  "block.minecraft.green_terracotta": "terrakotta aħdar",
  "block.minecraft.red_terracotta": "terrakotta aħmar",
  "block.minecraft.black_terracotta": "terrakotta sewda",
  "block.minecraft.barrier": "blokka inviżibli",
  "block.minecraft.iron_trapdoor": "bokkaport tal-ħadid",
  "block.minecraft.hay_block": "tiben",
  "block.minecraft.white_carpet": "tapit abjad",
  "block.minecraft.orange_carpet": "tapit oranġjo",
  "block.minecraft.magenta_carpet": "tapit roża skur",
  "block.minecraft.light_blue_carpet": "tapit blu ċar",
  "block.minecraft.yellow_carpet": "tapit isfar",
  "block.minecraft.lime_carpet": "tapit aħdar ċar",
  "block.minecraft.pink_carpet": "tapit roża",
  "block.minecraft.gray_carpet": "tapit griż",
  "block.minecraft.light_gray_carpet": "tapit griż ċar",
  "block.minecraft.cyan_carpet": "tapit blu fl-aħdar",
  "block.minecraft.purple_carpet": "tapit vjola",
  "block.minecraft.blue_carpet": "tapit blu",
  "block.minecraft.brown_carpet": "tapit kannella",
  "block.minecraft.green_carpet": "tapit aħdar",
  "block.minecraft.red_carpet": "tapit aħmar",
  "block.minecraft.black_carpet": "tapit iswed",
  "block.minecraft.terracotta": "terracotta",
  "block.minecraft.coal_block": "blokka tal-faħam",
  "block.minecraft.packed_ice": "silġ solidu",
  "block.minecraft.acacia_stairs": "turġien tal-aka ċja",
  "block.minecraft.dark_oak_stairs": "turġien skuri tal-ballut",
  "block.minecraft.slime_block": "blokka tal-ħama",
  "block.minecraft.grass_path": "passaġġ fil-ħaxix",
  "block.minecraft.sunflower": "ġirasol",
  "block.minecraft.lilac": "lela'",
  "block.minecraft.rose_bush": "xitla tal-ward",
  "block.minecraft.peony": "peony",
  "block.minecraft.tall_grass": "ħaxix twil",
  "block.minecraft.large_fern": "xitla kbira",
  "block.minecraft.white_stained_glass": "ħġieġ miżbugħ abjad",
  "block.minecraft.orange_stained_glass": "ħġieġ miżbugħ oranġjo",
  "block.minecraft.magenta_stained_glass": "ħġieġ miżbugħ vjola ċar",
  "block.minecraft.light_blue_stained_glass": "ħġieġ miżbugħ blu ċar",
  "block.minecraft.yellow_stained_glass": "ħġieġ miżbugħ isfar",
  "block.minecraft.lime_stained_glass": "ħġieġ miżbugħ aħdar ċar",
  "block.minecraft.pink_stained_glass": "ħġieġ miżbugħ roża",
  "block.minecraft.gray_stained_glass": "ħġieġ miżbugħ griż",
  "block.minecraft.light_gray_stained_glass": "ħġieġ miżbugħ griż ċar",
  "block.minecraft.cyan_stained_glass": "ħġieġ miżbugħ blu fl-aħdar",
  "block.minecraft.purple_stained_glass": "ħġieġ miżbugħ vjola",
  "block.minecraft.blue_stained_glass": "ħġieġ miżbugħ blu",
  "block.minecraft.brown_stained_glass": "ħġieġ miżbugħ kannella",
  "block.minecraft.green_stained_glass": "ħġieġ miżbugħ aħdar",
  "block.minecraft.red_stained_glass": "ħġieġ miżbugħ aħmar",
  "block.minecraft.black_stained_glass": "ħġieġ miżbugħ iswed",
  "block.minecraft.white_stained_glass_pane": "ħġieġa ċatta miżbugħha bajda ċara",
  "block.minecraft.orange_stained_glass_pane": "ħġieġa ċatta miżbugħha oranġjo ċar",
  "block.minecraft.magenta_stained_glass_pane": "ħġieġa ċatta miżbugħha vjola ċar",
  "block.minecraft.light_blue_stained_glass_pane": "ħġieġa ċatta miżbugħha blu ċar",
  "block.minecraft.yellow_stained_glass_pane": "ħġieġa ċatta miżbugħha safra",
  "block.minecraft.lime_stained_glass_pane": "ħġieġa ċatta miżbugħha ħadra ċara",
  "block.minecraft.pink_stained_glass_pane": "ħġieġa ċatta miżbugħha roża",
  "block.minecraft.gray_stained_glass_pane": "ħġieġa ċatta miżbugħha griża",
  "block.minecraft.light_gray_stained_glass_pane": "ħġieġa ċatta miżbugħha griża ċara",
  "block.minecraft.cyan_stained_glass_pane": "ħġieġa ċatta miżbugħha blu fl-aħdar",
  "block.minecraft.purple_stained_glass_pane": "ħġieġa ċatta miżbugħha vjola",
  "block.minecraft.blue_stained_glass_pane": "ħġieġa ċatta miżbugħha blu",
  "block.minecraft.brown_stained_glass_pane": "ħġieġa ċatta miżbugħha kannella",
  "block.minecraft.green_stained_glass_pane": "ħġieġa ċatta miżbugħha ħadra",
  "block.minecraft.red_stained_glass_pane": "ħġieġa ċatta miżbugħha ħamra",
  "block.minecraft.black_stained_glass_pane": "ħġieġa ċatta miżbugħha sewda",
  "block.minecraft.prismarine": "prismarine",
  "block.minecraft.prismarine_bricks": "briks tal-prismarine",
  "block.minecraft.dark_prismarine": "prismarine skur",
  "block.minecraft.prismarine_stairs": "turġien tal-ba ħar priismarine",
  "block.minecraft.prismarine_brick_stairs": "turġien prismarini tal-briks",
  "block.minecraft.dark_prismarine_stairs": "turġien fil-ba ħar prislama",
  "block.minecraft.sea_lantern": "mixegħela tal-baħar",
  "block.minecraft.red_sandstone": "ġebel aħmar tal-franka",
  "block.minecraft.chiseled_red_sandstone": "ġebel aħmar tal-franka mnaqqax",
  "block.minecraft.cut_red_sandstone": "qtugħ ta ' sandstone aħmar",
  "block.minecraft.red_sandstone_stairs": "taraġ tal-ġebel aħmar tal-franka",
  "block.minecraft.repeating_command_block": "blokka tal-kodiċi tirrepeti",
  "block.minecraft.chain_command_block": "blokka tal-kodiċi katina",
  "block.minecraft.magma_block": "blokka tal-magma",
  "block.minecraft.nether_wart_block": "blokka tal-faqqiegħ tan-nether",
  "block.minecraft.warped_wart_block": "blokka tal-felula stramb",
  "block.minecraft.red_nether_bricks": "brikks tan-neputi ħomor",
  "block.minecraft.bone_block": "blokka tal-għadam",
  "block.minecraft.structure_void": "struttura vojta",
  "block.minecraft.observer": "osservatur",
  "block.minecraft.shulker_box": "kaxxa ta ' shulker",
  "block.minecraft.white_shulker_box": "kaxxa ta ' shulker bajda",
  "block.minecraft.orange_shulker_box": "kaxxa ta ' shulker oranġjo",
  "block.minecraft.magenta_shulker_box": "kaxxa magenta shulker",
  "block.minecraft.light_blue_shulker_box": "kaxxa ta ' l-imulker blu ċar",
  "block.minecraft.yellow_shulker_box": "kaxxa safra tal-shulker",
  "block.minecraft.lime_shulker_box": "kaxxa tal-ġir shulker",
  "block.minecraft.pink_shulker_box": "kaxxa tal-shulker roża",
  "block.minecraft.gray_shulker_box": "kaxxa ta ' l-shulker gray",
  "block.minecraft.light_gray_shulker_box": "kaxxa ta ' l-shulker ħafif tal-gray",
  "block.minecraft.cyan_shulker_box": "kaxxa taċ-ċinan shulker",
  "block.minecraft.purple_shulker_box": "kaxxa ta ' shulker vjola",
  "block.minecraft.blue_shulker_box": "kaxxa tal-shulker blu",
  "block.minecraft.brown_shulker_box": "kaxxa tal-shulker kannella",
  "block.minecraft.green_shulker_box": "kaxxa tal-shulker kannella",
  "block.minecraft.red_shulker_box": "kaxxa ta ' shulker aħmar",
  "block.minecraft.black_shulker_box": "kaxxa ta ' shulker iswed",
  "block.minecraft.white_glazed_terracotta": "terracotta tal-ħġieġ abjad",
  "block.minecraft.orange_glazed_terracotta": "terracotta ta ' ħġieġ oranġjo",
  "block.minecraft.magenta_glazed_terracotta": "ħġieġ magenta terracotta",
  "block.minecraft.light_blue_glazed_terracotta": "terrakotta bit-tleqqija ikħal ċar",
  "block.minecraft.yellow_glazed_terracotta": "terrakotta bit-tleqqija safrani",
  "block.minecraft.lime_glazed_terracotta": "terrakotta bit-tleqqija aħdar ċar",
  "block.minecraft.pink_glazed_terracotta": "terrakotta bi tleqqija roża",
  "block.minecraft.gray_glazed_terracotta": "terrakotta bi tleqqija griża",
  "block.minecraft.light_gray_glazed_terracotta": "terrakotta bi tleqqija griż ċar",
  "block.minecraft.cyan_glazed_terracotta": "terrakotta bi tleqqija cyan",
  "block.minecraft.purple_glazed_terracotta": "terrakotta bi tleqqija vjola",
  "block.minecraft.blue_glazed_terracotta": "terrakotta bi tleqqija ikħal",
  "block.minecraft.brown_glazed_terracotta": "terrakotta bi tleqqija kannella",
  "block.minecraft.green_glazed_terracotta": "terrakotta bi tleqqija ħadra",
  "block.minecraft.red_glazed_terracotta": "terrakotta bi tleqqija ħamra",
  "block.minecraft.black_glazed_terracotta": "terrakotta bi tleqqija sewda",
  "block.minecraft.white_concrete": "konkrit abjad",
  "block.minecraft.orange_concrete": "konkrit oranġjo",
  "block.minecraft.magenta_concrete": "konkrit maġenta",
  "block.minecraft.light_blue_concrete": "konkrit ikħal ċar",
  "block.minecraft.yellow_concrete": "konkrit isfar",
  "block.minecraft.lime_concrete": "konkrit aħdar ċar",
  "block.minecraft.pink_concrete": "konkrit roża",
  "block.minecraft.gray_concrete": "konkrit griż",
  "block.minecraft.light_gray_concrete": "konkrit griż ċar",
  "block.minecraft.cyan_concrete": "konkrit cyan",
  "block.minecraft.purple_concrete": "konkrit vjola",
  "block.minecraft.blue_concrete": "konkrit ikħal",
  "block.minecraft.brown_concrete": "konkrit kannella",
  "block.minecraft.green_concrete": "konkrit aħdar",
  "block.minecraft.red_concrete": "konkrit aħmar",
  "block.minecraft.black_concrete": "konkrit iswed",
  "block.minecraft.white_concrete_powder": "trab abjad tal-konkrit",
  "block.minecraft.orange_concrete_powder": "trab oranġjo tal-konkrit",
  "block.minecraft.magenta_concrete_powder": "trab maġenta tal-konkrit",
  "block.minecraft.light_blue_concrete_powder": "trab ikħal ċar tal-konkrit",
  "block.minecraft.yellow_concrete_powder": "trab isfar tal-konkrit",
  "block.minecraft.lime_concrete_powder": "trab aħdar ċar tal-konkrit",
  "block.minecraft.pink_concrete_powder": "trab roża tal-konkrit",
  "block.minecraft.gray_concrete_powder": "trab griż tal-konkrit",
  "block.minecraft.light_gray_concrete_powder": "trab griż ċar tal-konkrit",
  "block.minecraft.cyan_concrete_powder": "trab cyan tal-konkrit",
  "block.minecraft.purple_concrete_powder": "trab vjola tal-konkrit",
  "block.minecraft.blue_concrete_powder": "trab ikħal tal-konkrit",
  "block.minecraft.brown_concrete_powder": "trab kannella tal-konkrit",
  "block.minecraft.green_concrete_powder": "trab aħdar tal-konkrit",
  "block.minecraft.red_concrete_powder": "trab aħmar tal-konkrit",
  "block.minecraft.black_concrete_powder": "trab iswed tal-konkrit",
  "block.minecraft.turtle_egg": "bajda tal-fekruna",
  "block.minecraft.dead_tube_coral_block": "blokk tal-korall b ' tubu mejjet",
  "block.minecraft.dead_brain_coral_block": "blokk tal-qroll tal-mo ħħ mejjet",
  "block.minecraft.dead_bubble_coral_block": "blokka tal-korall tal-bu żżieqa mejta",
  "block.minecraft.dead_fire_coral_block": "blokka tal-korall tan-nar mejta",
  "block.minecraft.dead_horn_coral_block": "blokk tal-korall tal-qrun mejjet",
  "block.minecraft.tube_coral_block": "blokka tal-korall tat-tubu",
  "block.minecraft.brain_coral_block": "blokk tal-qroll tal-moħħ",
  "block.minecraft.bubble_coral_block": "bubble coral block",
  "block.minecraft.fire_coral_block": "blokk tal-qroll tan-nar",
  "block.minecraft.horn_coral_block": "blokka korall tal-qrun",
  "block.minecraft.tube_coral": "qroll tat-tubu",
  "block.minecraft.brain_coral": "qroll tal-mo ħħ",
  "block.minecraft.bubble_coral": "korall tal-bu żżieqa",
  "block.minecraft.fire_coral": "qroll tan-nar",
  "block.minecraft.horn_coral": "qroll tal-qrun",
  "block.minecraft.dead_brain_coral": "qroll tal-mo ħħ mejjet",
  "block.minecraft.dead_bubble_coral": "qroll tal-bu żżieqa mejta",
  "block.minecraft.dead_fire_coral": "qroll tan-nar mejjet",
  "block.minecraft.dead_horn_coral": "qroll tal-qrun mejjet",
  "block.minecraft.dead_tube_coral": "qroll ta ' tubu mejjet",
  "block.minecraft.tube_coral_fan": "fan tal-korall tat-tubu",
  "block.minecraft.brain_coral_fan": "fann tal-qroll tal-mo ħħ",
  "block.minecraft.bubble_coral_fan": "mrewħa tal-bu żżieqa",
  "block.minecraft.fire_coral_fan": "fann għall-qroll tan-nar",
  "block.minecraft.horn_coral_fan": "fann għall-qroll tal-qrun",
  "block.minecraft.dead_tube_coral_fan": "fan tal-korall b ' tubu mejjet",
  "block.minecraft.dead_brain_coral_fan": "fann tal-korall tal-mo ħħ mejjet",
  "block.minecraft.dead_bubble_coral_fan": "fann tal-korall tal-bu żżieqa mejta",
  "block.minecraft.dead_fire_coral_fan": "fann tal-korall tan-nar mejjet",
  "block.minecraft.dead_horn_coral_fan": "fann tal-korall tal-qrun mejjet",
  "block.minecraft.blue_ice": "silġ blu",
  "block.minecraft.conduit": "kondu ċent",
  "block.minecraft.polished_granite_stairs": "polished granite stairs",
  "block.minecraft.smooth_red_sandstone_stairs": "it-tara ġ aħmar sandstone",
  "block.minecraft.mossy_stone_brick_stairs": "it-tur ġien tal-briks tal-ġebel mossija",
  "block.minecraft.polished_diorite_stairs": "turġien tad-dijorite illustrati",
  "block.minecraft.mossy_cobblestone_stairs": "kosija cobblestone turġien",
  "block.minecraft.end_stone_brick_stairs": "temm it-tur ġien tal-briks",
  "block.minecraft.stone_stairs": "turġien fuq il-ġebel",
  "block.minecraft.smooth_sandstone_stairs": "faċli sandstone turġien",
  "block.minecraft.smooth_quartz_stairs": "turġien lixxi tal-kwarz",
  "block.minecraft.granite_stairs": "turġien tal-granit",
  "block.minecraft.andesite_stairs": "it-tur ġien tat-t ¢ bien",
  "block.minecraft.red_nether_brick_stairs": "turġien ħomor tal-briks",
  "block.minecraft.polished_andesite_stairs": "turġien tat-estint illustrati",
  "block.minecraft.diorite_stairs": "turġien tad-diorite",
  "block.minecraft.polished_granite_slab": "blokka tal-granit illustrati",
  "block.minecraft.smooth_red_sandstone_slab": "blokka tas-sandstone ħamra",
  "block.minecraft.mossy_stone_brick_slab": "blokka tal-briks tal-ġebel mossija",
  "block.minecraft.polished_diorite_slab": "blokka diorite llustrata",
  "block.minecraft.mossy_cobblestone_slab": "cobblestone blokka ta ' mossija",
  "block.minecraft.end_stone_brick_slab": "tarf tal-briks tal-ġebla",
  "block.minecraft.smooth_sandstone_slab": "blokka tal-ġebel imrammel lixxa",
  "block.minecraft.smooth_quartz_slab": "blokka tal-kwarz lixxa",
  "block.minecraft.granite_slab": "blokka tal-granit",
  "block.minecraft.andesite_slab": "il-blokka tat-estint",
  "block.minecraft.red_nether_brick_slab": "blokka tal-briks tan-nether ħamra",
  "block.minecraft.polished_andesite_slab": "blokka tat-estint illustrati",
  "block.minecraft.diorite_slab": "blokka tad-diorite",
  "block.minecraft.scaffolding": "armar",
  "block.minecraft.iron_door": "bieb tal-ħadid",
  "block.minecraft.oak_door": "bieb tal-ballut",
  "block.minecraft.spruce_door": "bieb tal-arżnu",
  "block.minecraft.birch_door": "bieb tal-betula",
  "block.minecraft.jungle_door": "bieb tal-injam tal-ġungla",
  "block.minecraft.acacia_door": "bieb tal-akaċja",
  "block.minecraft.dark_oak_door": "bieb tal-ballut skur",
  "block.minecraft.crimson_door": "bieb krimżi",
  "block.minecraft.warped_door": "bieb stramb",
  "block.minecraft.repeater": "dajowd tar-redstone",
  "block.minecraft.comparator": "komparatur tar-redstone",
  "block.minecraft.structure_block": "blokka tal-istruttura",
  "block.minecraft.jigsaw": "blokk ta ' jigsaw",
  "item.minecraft.turtle_helmet": "qoxra tal-fekruna□□meta tkun fuq ir-ras:□+2armar",
  "item.minecraft.scute": "skute",
  "item.minecraft.iron_shovel": "pala tal-ħadid□□meta tkun fl-id prinċipali:□+3.5ħsara tal-attakk□-3veloċità tal-attakk",
  "item.minecraft.iron_pickaxe": "baqqun tal-ħadid□□meta tkun fl-id prinċipali:□+3ħsara tal-attakk□-2.8veloċità tal-attakk",
  "item.minecraft.iron_axe": "mannara tal-ħadid□□meta tkun fl-id prinċipali:□+8ħsara tal-attakk□-3.1veloċità tal-attakk",
  "item.minecraft.flint_and_steel": "żnied u ħadida",
  "item.minecraft.apple": "tuffieħa",
  "item.minecraft.bow": "qaws",
  "item.minecraft.arrow": "vleġġa",
  "item.minecraft.coal": "faħam",
  "item.minecraft.charcoal": "faħam tal-injam",
  "item.minecraft.diamond": "djamant",
  "item.minecraft.iron_ingot": "ingott tal-ħadid",
  "item.minecraft.gold_ingot": "ingott tad-deheb",
  "item.minecraft.netherite_ingot": "ingott tan-netherajt",
  "item.minecraft.netherite_scrap": "ferralja tan-netherajt",
  "item.minecraft.iron_sword": "xabla tal-ħadid□□meta tkun fl-id prinċipali:□+5ħsara tal-attakk□-2.4veloċità tal-attakk",
  "item.minecraft.wooden_sword": "xabla tal-injam□□meta tkun fl-id prinċipali:□+3ħsara tal-attakk□-2.4veloċità tal-attakk",
  "item.minecraft.wooden_shovel": "pala tal-injam□□meta tkun fl-id prinċipali:□+1.5ħsara tal-attakk□-3veloċità tal-attakk",
  "item.minecraft.wooden_pickaxe": "baqqun tal-injam□□meta tkun fl-id prinċipali:□+1ħsara tal-attakk□-2.8veloċità tal-attakk",
  "item.minecraft.wooden_axe": "mannara tal-injam□□meta tkun fl-id prinċipali:□+6ħsara tal-attakk□-3.2veloċità tal-attakk",
  "item.minecraft.stone_sword": "xabla tal-ġebel□□meta tkun fl-id prinċipali:□+4ħsara tal-attakk□-2.4veloċità tal-attakk",
  "item.minecraft.stone_shovel": "pala tal-ġebel□□meta tkun fl-id prinċipali:□+2.5ħsara tal-attakk□-3veloċità tal-attakk",
  "item.minecraft.stone_pickaxe": "baqqun tal-ġebel□□meta tkun fl-id prinċipali:□+2ħsara tal-attakk□-2.8veloċità tal-attakk",
  "item.minecraft.stone_axe": "mannara tal-ġebel□□meta tkun fl-id prinċipali:□+8ħsara tal-attakk□-3.2veloċità tal-attakk",
  "item.minecraft.diamond_sword": "xabla tad-djamant□□meta tkun fl-id prinċipali:□+6ħsara tal-attakk□-2.4veloċità tal-attakk",
  "item.minecraft.diamond_shovel": "pala tad-djamant□□meta tkun fl-id prinċipali:□+4.5ħsara tal-attakk□-3veloċità tal-attakk",
  "item.minecraft.diamond_pickaxe": "baqqun tad-djamant□□meta tkun fl-id prinċipali:□+4ħsara tal-attakk□-2.8veloċità tal-attakk",
  "item.minecraft.diamond_axe": "mannara tad-djamant□□meta tkun fl-id prinċipali:□+8ħsara tal-attakk□-3veloċità tal-attakk",
  "item.minecraft.stick": "stikka",
  "item.minecraft.bowl": "skutella",
  "item.minecraft.mushroom_stew": "stuffat tal-faqqiegħ",
  "item.minecraft.golden_sword": "xabla tad-deheb□□meta tkun fl-id prinċipali:□+3ħsara tal-attakk□-2.4veloċità tal-attakk",
  "item.minecraft.golden_shovel": "pala tad-deheb□□meta tkun fl-id prinċipali:□+1.5ħsara tal-attakk□-3veloċità tal-attakk",
  "item.minecraft.golden_pickaxe": "baqqun tad-deheb□□meta tkun fl-id prinċipali:□+1ħsara tal-attakk□-2.8veloċità tal-attakk",
  "item.minecraft.golden_axe": "mannara tad-deheb□□meta tkun fl-id prinċipali:□+6ħsara tal-attakk□-3veloċità tal-attakk",
  "item.minecraft.netherite_sword": "xabla tan-netherajt□□meta tkun fl-id prinċipali:□+7ħsara tal-attakk□-2.4veloċità tal-attakk",
  "item.minecraft.netherite_shovel": "pala tan-netherajt□□meta tkun fl-id prinċipali:□+5.5ħsara tal-attakk□-3veloċità tal-attakk",
  "item.minecraft.netherite_pickaxe": "baqqun tan-netherajt□□meta tkun fl-id prinċipali:□+5ħsara tal-attakk□-2.8veloċità tal-attakk",
  "item.minecraft.netherite_axe": "mannara tan-netherajt□□meta tkun fl-id prinċipali:□+9ħsara tal-attakk□-3veloċità tal-attakk",
  "item.minecraft.string": "spaga",
  "item.minecraft.feather": "rixa",
  "item.minecraft.gunpowder": "porvli",
  "item.minecraft.wooden_hoe": "mgħażqa tal-injam□□meta tkun fl-id prinċipali:□-3veloċità tal-attakk",
  "item.minecraft.stone_hoe": "mgħażqa tal-ġebel□□meta tkun fl-id prinċipali:□-2veloċità tal-attakk",
  "item.minecraft.iron_hoe": "mgħażqa tal-ħadid□□meta tkun fl-id prinċipali:□-1veloċità tal-attakk",
  "item.minecraft.diamond_hoe": "mgħażqa tad-djamant□□meta tkun fl-id prinċipali:",
  "item.minecraft.golden_hoe": "mgħażqa tad-deheb□□meta tkun fl-id prinċipali:□-3veloċità tal-attakk",
  "item.minecraft.netherite_hoe": "mgħażqa tan-netherajt□□meta tkun fl-id prinċipali:",
  "item.minecraft.wheat_seeds": "żerriegħa tal-qam ħ",
  "item.minecraft.wheat": "qamħ",
  "item.minecraft.bread": "ħobż",
  "item.minecraft.leather_helmet": "kappa tal-ġilda□□meta tkun fuq ir-ras:□+1armar",
  "item.minecraft.leather_chestplate": "flokk tal-ġilda□□meta tkun fuq il-ġisem:□+3armar",
  "item.minecraft.leather_leggings": "qalziet tal-ġilda□□meta tkun fir-riġlejn:□+2armar",
  "item.minecraft.leather_boots": "żraben tal-ġilda□□meta tkun fuq saqajn:□+1armar",
  "item.minecraft.chainmail_helmet": "chainmail helmet□□meta tkun fuq ir-ras:□+2armar",
  "item.minecraft.chainmail_chestplate": "pjanċa tal-qastan□□meta tkun fuq il-ġisem:□+5armar",
  "item.minecraft.chainmail_leggings": "leggings tal-chainmail□□meta tkun fir-riġlejn:□+4armar",
  "item.minecraft.chainmail_boots": "żraben tal-chainmail□□meta tkun fuq saqajn:□+1armar",
  "item.minecraft.iron_helmet": "elmu tal-ħadid□□meta tkun fuq ir-ras:□+2armar",
  "item.minecraft.iron_chestplate": "armar tal-ħadid□□meta tkun fuq il-ġisem:□+6armar",
  "item.minecraft.iron_leggings": "saqajn tal-ħadid□□meta tkun fir-riġlejn:□+5armar",
  "item.minecraft.iron_boots": "żraben tal-ħadid□□meta tkun fuq saqajn:□+2armar",
  "item.minecraft.diamond_helmet": "elum tad-djamant□□meta tkun fuq ir-ras:□+3armar□+2saħħa tal-armar",
  "item.minecraft.diamond_chestplate": "armar tad-djamant□□meta tkun fuq il-ġisem:□+8armar□+2saħħa tal-armar",
  "item.minecraft.diamond_leggings": "saqajn tad-djamant□□meta tkun fir-riġlejn:□+6armar□+2saħħa tal-armar",
  "item.minecraft.diamond_boots": "żraben tad-djamant□□meta tkun fuq saqajn:□+3armar□+2saħħa tal-armar",
  "item.minecraft.golden_helmet": "elum tad-deheb□□meta tkun fuq ir-ras:□+2armar",
  "item.minecraft.golden_chestplate": "armar tad-deheb□□meta tkun fuq il-ġisem:□+5armar",
  "item.minecraft.golden_leggings": "saqajn tad-deheb□□meta tkun fir-riġlejn:□+3armar",
  "item.minecraft.golden_boots": "żraben tad-deheb□□meta tkun fuq saqajn:□+1armar",
  "item.minecraft.netherite_helmet": "elmu tan-netherajt□□meta tkun fuq ir-ras:□+3armar□+3saħħa tal-armar□+1resistenza għall-imbuttar",
  "item.minecraft.netherite_chestplate": "biċċa tas-sider tan-netherajt□□meta tkun fuq il-ġisem:□+8armar□+3saħħa tal-armar□+1resistenza għall-imbuttar",
  "item.minecraft.netherite_leggings": "qalziet tan-netherajt□□meta tkun fir-riġlejn:□+6armar□+3saħħa tal-armar□+1resistenza għall-imbuttar",
  "item.minecraft.netherite_boots": "bwiez tan-netherajt□□meta tkun fuq saqajn:□+3armar□+3saħħa tal-armar□+1resistenza għall-imbuttar",
  "item.minecraft.flint": "żnied",
  "item.minecraft.porkchop": "majjal nej",
  "item.minecraft.cooked_porkchop": "majjal imsajjar",
  "item.minecraft.painting": "pittura",
  "item.minecraft.golden_apple": "tuffieħa tad-deheb",
  "item.minecraft.enchanted_golden_apple": "enchanted golden apple",
  "block.minecraft.oak_sign": "sinjal tal-ballut",
  "block.minecraft.spruce_sign": "sinjal ta ' spruce",
  "block.minecraft.birch_sign": "sinjal tal-betula",
  "block.minecraft.jungle_sign": "sinjal tal-ġungla",
  "block.minecraft.acacia_sign": "sinjal tal-aka ċja",
  "block.minecraft.dark_oak_sign": "sinjal skur tal-ballut",
  "block.minecraft.crimson_sign": "tabella krimżi",
  "block.minecraft.warped_sign": "tabella stramba",
  "item.minecraft.bucket": "barmil",
  "item.minecraft.water_bucket": "barmil ilma",
  "item.minecraft.lava_bucket": "barmil lava",
  "item.minecraft.minecart": "karretta",
  "item.minecraft.saddle": "sarġ",
  "item.minecraft.redstone": "trab tar-redstone",
  "item.minecraft.snowball": "ballun tas-silġ",
  "item.minecraft.oak_boat": "dgħajsa tal-ballut",
  "item.minecraft.leather": "ġilda",
  "item.minecraft.milk_bucket": "barmil tal-ħalib",
  "item.minecraft.pufferfish_bucket": "barmil ta ' pufferfish",
  "item.minecraft.salmon_bucket": "barmil tas-salamun",
  "item.minecraft.cod_bucket": "barmil tal-bakkaljaw",
  "item.minecraft.tropical_fish_bucket": "barmil tal-ħut tropikali",
  "item.minecraft.brick": "briksa",
  "item.minecraft.clay_ball": "ballun tat-tafal",
  "block.minecraft.dried_kelp_block": "blokk kelp imnixxef",
  "item.minecraft.paper": "karta",
  "item.minecraft.book": "ktieb",
  "item.minecraft.slime_ball": "ballun tal-ħama",
  "item.minecraft.chest_minecart": "karretta b'senduq",
  "item.minecraft.furnace_minecart": "karretta b'forn",
  "item.minecraft.egg": "bajda",
  "item.minecraft.compass": "boxla",
  "item.minecraft.fishing_rod": "qasba tas-sajd",
  "item.minecraft.clock": "arloġġ",
  "item.minecraft.glowstone_dust": "trab tal-ġebel jixgħel",
  "item.minecraft.cod": "bakkaljaw mhux maħdum",
  "item.minecraft.salmon": "salamun nej",
  "item.minecraft.tropical_fish": "ħut tropikali",
  "item.minecraft.pufferfish": "ħuta velenuża",
  "item.minecraft.cooked_cod": "merluzz imsajjar",
  "item.minecraft.cooked_salmon": "salamun imsajjar",
  "item.minecraft.ink_sac": "inka",
  "item.minecraft.red_dye": "żebgħa ħamra",
  "item.minecraft.green_dye": "żebgħa ħadra",
  "item.minecraft.cocoa_beans": "fażola tal-kawkaw",
  "item.minecraft.lapis_lazuli": "lapis lazuli",
  "item.minecraft.purple_dye": "żebgħa vjola",
  "item.minecraft.cyan_dye": "żebgħa blu fl-aħdar",
  "item.minecraft.light_gray_dye": "żebgħa griża ċara",
  "item.minecraft.gray_dye": "żebgħa griża",
  "item.minecraft.pink_dye": "żebgħa roża",
  "item.minecraft.lime_dye": "żebgħa ħadra ċara",
  "item.minecraft.yellow_dye": "kulur isfar",
  "item.minecraft.light_blue_dye": "żebgħa blu ċara",
  "item.minecraft.magenta_dye": "żebgħa vjola ċara",
  "item.minecraft.orange_dye": "żebgħa oranġjo",
  "item.minecraft.bone_meal": "fertilizzant",
  "item.minecraft.blue_dye": "żebgħa kaħla",
  "item.minecraft.brown_dye": "żebgħa kannella",
  "item.minecraft.black_dye": "kulur iswed",
  "item.minecraft.white_dye": "kulur abjad",
  "item.minecraft.bone": "għadma",
  "item.minecraft.sugar": "zokkor",
  "block.minecraft.cake": "kejk",
  "block.minecraft.white_bed": "sodda bajda",
  "block.minecraft.orange_bed": "sodda orangjo",
  "block.minecraft.magenta_bed": "sodda ta ' maġenta",
  "block.minecraft.light_blue_bed": "sodda blu ħafifa",
  "block.minecraft.yellow_bed": "sodda safra",
  "block.minecraft.lime_bed": "sodda tal-lajm",
  "block.minecraft.pink_bed": "sodda roża",
  "block.minecraft.gray_bed": "sodda griża",
  "block.minecraft.light_gray_bed": "sodda griża ċara",
  "block.minecraft.cyan_bed": "sodda tal-qieg ħ",
  "block.minecraft.purple_bed": "sodda vjola",
  "block.minecraft.blue_bed": "sodda ikħal",
  "block.minecraft.brown_bed": "sodda kannella",
  "block.minecraft.green_bed": "sodda ħadra",
  "block.minecraft.red_bed": "sodda ħamra",
  "block.minecraft.black_bed": "sodda sewda",
  "item.minecraft.cookie": "gallettina",
  "item.minecraft.filled_map": "mappa□#0",
  "item.minecraft.shears": "ġliem",
  "item.minecraft.melon_slice": "melon porzjon",
  "item.minecraft.dried_kelp": "kelp imnixxfa",
  "item.minecraft.pumpkin_seeds": "żerriegħa tal-qargħa ħamra",
  "item.minecraft.melon_seeds": "żerriegħa tad-dulliegħ",
  "item.minecraft.beef": "ċanga nejja",
  "item.minecraft.cooked_beef": "ċanga msajra",
  "item.minecraft.chicken": "tiġieġa nejja",
  "item.minecraft.cooked_chicken": "tiġieġa msajra",
  "item.minecraft.rotten_flesh": "laħam maqtugħ",
  "item.minecraft.ender_pearl": "perla tal-ender",
  "item.minecraft.blaze_rod": "virga tan-nar",
  "item.minecraft.ghast_tear": "demgħa ta' ghast",
  "item.minecraft.gold_nugget": "farka tad-deheb",
  "item.minecraft.nether_wart": "faqqiegħ tan-nether",
  "item.minecraft.potion": "xarba impossibbli□bla ebda effetti",
  "item.minecraft.glass_bottle": "flixkun tal-ħġieġ",
  "item.minecraft.spider_eye": "għajn ta' brimba",
  "item.minecraft.fermented_spider_eye": "għajn ta' brimba ffermentata",
  "item.minecraft.blaze_powder": "trab tan-nar",
  "item.minecraft.magma_cream": "krema tal-magma",
  "block.minecraft.brewing_stand": "birrerija",
  "block.minecraft.cauldron": "kaldarun",
  "item.minecraft.ender_eye": "għajn tal-ender",
  "item.minecraft.glistering_melon_slice": "glistering melon porzjon",
  "item.minecraft.bat_spawn_egg": "bajda tal-bajd",
  "item.minecraft.bee_spawn_egg": "bajd tan-na ħal",
  "item.minecraft.blaze_spawn_egg": "il-bajda",
  "item.minecraft.cat_spawn_egg": "qattus tal-bajd tal-qtates",
  "item.minecraft.cave_spider_spawn_egg": "grotta tal-bajd",
  "item.minecraft.chicken_spawn_egg": "bajda tal-bajd tat-ti ġieġ",
  "item.minecraft.cod_spawn_egg": "merluzz tal-bajd",
  "item.minecraft.cow_spawn_egg": "bajda tal-bajd tal-baqra",
  "item.minecraft.creeper_spawn_egg": "bajda",
  "item.minecraft.dolphin_spawn_egg": "bajd tad-dniefel",
  "item.minecraft.donkey_spawn_egg": "donnu l-bajda tal-bajd",
  "item.minecraft.drowned_spawn_egg": "bajd mill-ħmieġ tal-ħaxix",
  "item.minecraft.elder_guardian_spawn_egg": "il-bajda",
  "item.minecraft.enderman_spawn_egg": "il-bajd ta ' l-enderman",
  "item.minecraft.endermite_spawn_egg": "bajd ta ' l-endermite",
  "item.minecraft.evoker_spawn_egg": "bajda tal-bajd (evoker)",
  "item.minecraft.fox_spawn_egg": "bajda tal-volpi",
  "item.minecraft.ghast_spawn_egg": "bajda tal-bajd ghast",
  "item.minecraft.guardian_spawn_egg": "guardian spawn egg",
  "item.minecraft.hoglin_spawn_egg": "bajda tal-hoglin",
  "item.minecraft.horse_spawn_egg": "bajd taż-żiemel",
  "item.minecraft.husk_spawn_egg": "qoxra tal-ħliefa tal-bajd",
  "item.minecraft.llama_spawn_egg": "il-bajd llama",
  "item.minecraft.magma_cube_spawn_egg": "il-bajd b ' kubu ta ' magma",
  "item.minecraft.mooshroom_spawn_egg": "mooshroom tal-bajd",
  "item.minecraft.mule_spawn_egg": "bajda tal-bajd",
  "item.minecraft.ocelot_spawn_egg": "bajd ta ' l-ocelot",
  "item.minecraft.panda_spawn_egg": "bajda tal-bajd tas-saln",
  "item.minecraft.parrot_spawn_egg": "bajda tal-bajd tal-pappagall",
  "item.minecraft.phantom_spawn_egg": "bajd phantom",
  "item.minecraft.pig_spawn_egg": "bajda tal-bajd tal-majjal",
  "item.minecraft.piglin_spawn_egg": "bajda tal-piglin",
  "item.minecraft.pillager_spawn_egg": "pillager tal-bajd",
  "item.minecraft.polar_bear_spawn_egg": "bajd polari",
  "item.minecraft.pufferfish_spawn_egg": "pufferfish tal-bajd",
  "item.minecraft.rabbit_spawn_egg": "bajda tal-bajd tal-fenek",
  "item.minecraft.ravager_spawn_egg": "il-bajd tar-ravager",
  "item.minecraft.salmon_spawn_egg": "bajd tas-salamun",
  "item.minecraft.sheep_spawn_egg": "bajd tan-nag ħaġ",
  "item.minecraft.shulker_spawn_egg": "bajda tal-bajd tas-shulker",
  "item.minecraft.silverfish_spawn_egg": "bajd tal-fidda",
  "item.minecraft.skeleton_spawn_egg": "bajda tal-bajd",
  "item.minecraft.skeleton_horse_spawn_egg": "żiemel tal-bajd tal-iskeletru",
  "item.minecraft.slime_spawn_egg": "bajda tal-bajd tas-sġir",
  "item.minecraft.spider_spawn_egg": "bajda tal-bajd tas-spider",
  "item.minecraft.squid_spawn_egg": "il-bajd tal-klamari",
  "item.minecraft.stray_spawn_egg": "bajda",
  "item.minecraft.strider_spawn_egg": "bajda ta' l-istrajder",
  "item.minecraft.trader_llama_spawn_egg": "il-bajd fil-kummer ċjant llama",
  "item.minecraft.tropical_fish_spawn_egg": "tropical fish spawn egg",
  "item.minecraft.turtle_spawn_egg": "bajda bajd tal-fekruna",
  "item.minecraft.vex_spawn_egg": "vex tal-bajd",
  "item.minecraft.villager_spawn_egg": "il-bajd ta ' villager",
  "item.minecraft.vindicator_spawn_egg": "bajd li jbid vindikatur",
  "item.minecraft.wandering_trader_spawn_egg": "il-bajd ta ' l-i wandering kummerċjant",
  "item.minecraft.witch_spawn_egg": "dawwar il-bajda tal-bajd",
  "item.minecraft.wither_skeleton_spawn_egg": "il-bajda tal-bajd wither",
  "item.minecraft.wolf_spawn_egg": "bajd tal-lupu li minnu",
  "item.minecraft.zoglin_spawn_egg": "bajda taż-zogin",
  "item.minecraft.zombie_spawn_egg": "zapping tal-bajd",
  "item.minecraft.zombie_horse_spawn_egg": "bajd taż-żiemel zapping",
  "item.minecraft.zombie_villager_spawn_egg": "zapping villager tal-bajd",
  "item.minecraft.zombified_piglin_spawn_egg": "bajda tal-piglin żombifikat",
  "item.minecraft.experience_bottle": "flixkun tal-maġija",
  "item.minecraft.fire_charge": "balma tan-nar",
  "item.minecraft.writable_book": "ktieb bir-rixa",
  "item.minecraft.written_book": "ktieb miktub",
  "item.minecraft.emerald": "żmerald",
  "item.minecraft.item_frame": "inkwatru",
  "block.minecraft.flower_pot": "qasrija",
  "item.minecraft.carrot": "karrotta",
  "item.minecraft.potato": "patata",
  "item.minecraft.baked_potato": "patata msajra",
  "item.minecraft.poisonous_potato": "patata velenuża",
  "item.minecraft.map": "mappa vojta",
  "item.minecraft.golden_carrot": "karrotta tad-deheb",
  "block.minecraft.skeleton_skull": "ras ta' skeletru",
  "block.minecraft.wither_skeleton_skull": "ras ta' skeletru tal-wither",
  "block.minecraft.player_head": "kap tal-plejer",
  "block.minecraft.zombie_head": "ras ta' mostru",
  "block.minecraft.creeper_head": "ras ta' creeper",
  "block.minecraft.dragon_head": "ras ta' dragun",
  "item.minecraft.carrot_on_a_stick": "karrotta fuq stikka",
  "item.minecraft.warped_fungus_on_a_stick": "fungu stramb fuq stikka",
  "item.minecraft.nether_star": "stilla tan-nether",
  "item.minecraft.pumpkin_pie": "torta tal-qargħa ħamra",
  "item.minecraft.firework_rocket": "murtal",
  "item.minecraft.firework_star": "balma tal-murtali",
  "item.minecraft.enchanted_book": "ktieb maġiku",
  "item.minecraft.nether_brick": "briks tan-nether",
  "item.minecraft.quartz": "kwarz tan-nether",
  "item.minecraft.tnt_minecart": "karretta bl-isplussivi",
  "item.minecraft.hopper_minecart": "karretta b'lembut",
  "item.minecraft.prismarine_shard": "farka tal-prismarine",
  "item.minecraft.prismarine_crystals": "kristalli tal-prismarine",
  "item.minecraft.rabbit": "fenek nej",
  "item.minecraft.cooked_rabbit": "fenek imsajjar",
  "item.minecraft.rabbit_stew": "stuffat tal-fenek",
  "item.minecraft.rabbit_foot": "sieq il-fenek",
  "item.minecraft.rabbit_hide": "ġilda tal-fenek",
  "item.minecraft.armor_stand": "stand tal-armar",
  "item.minecraft.iron_horse_armor": "armar taż-żwiemel tal-ħadid",
  "item.minecraft.golden_horse_armor": "il-armati taż-żiemel",
  "item.minecraft.diamond_horse_armor": "armar taż-żwiemel tad-djamant",
  "item.minecraft.leather_horse_armor": "armor tal-ġilda",
  "item.minecraft.lead": "ċinga",
  "item.minecraft.name_tag": "tikketta",
  "item.minecraft.command_block_minecart": "karretta bi blokka tal-kodiċi",
  "item.minecraft.mutton": "laħam tan-nagħġa nej",
  "item.minecraft.cooked_mutton": "laħam tan-nagħġa msajjar",
  "block.minecraft.white_banner": "bandiera bajda",
  "block.minecraft.orange_banner": "bandiera oranġjo",
  "block.minecraft.magenta_banner": "bandira roża skur",
  "block.minecraft.light_blue_banner": "bandiera blu ċar",
  "block.minecraft.yellow_banner": "bandiera safra",
  "block.minecraft.lime_banner": "bandiera ħadra ċara",
  "block.minecraft.pink_banner": "bandiera roża",
  "block.minecraft.gray_banner": "bandiera griża",
  "block.minecraft.light_gray_banner": "bandiera griża ċara",
  "block.minecraft.cyan_banner": "bandiera blu fl-aħdar",
  "block.minecraft.purple_banner": "bandiera vjola",
  "block.minecraft.blue_banner": "bandiera blu",
  "block.minecraft.brown_banner": "bandiera kannella",
  "block.minecraft.green_banner": "bandiera ħadra",
  "block.minecraft.red_banner": "bandiera ħamra",
  "block.minecraft.black_banner": "bandiera sewda",
  "item.minecraft.end_crystal": "kristall tal-ender",
  "item.minecraft.chorus_fruit": "frotta tal-chorus",
  "item.minecraft.popped_chorus_fruit": "frotta tal-chorus mifqugħha",
  "item.minecraft.beetroot": "pitrava",
  "item.minecraft.beetroot_seeds": "żerriegħa tal-pitravi",
  "item.minecraft.beetroot_soup": "soppa tal-pitravi",
  "item.minecraft.dragon_breath": "nifs ta' dragun",
  "item.minecraft.splash_potion": "xarba tinxtered impossibbli□bla ebda effetti",
  "item.minecraft.spectral_arrow": "vleġġa spettrali",
  "item.minecraft.tipped_arrow": "vleġġa bil-ponta□bla ebda effetti",
  "item.minecraft.lingering_potion": "xarba impossibbli fumanti□bla ebda effetti",
  "item.minecraft.shield": "tarka",
  "item.minecraft.elytra": "elytra",
  "item.minecraft.spruce_boat": "dgħajsa tal-arżnu",
  "item.minecraft.birch_boat": "dgħajsa tal-betula",
  "item.minecraft.jungle_boat": "dgħajsa tal-injam tal-ġungla",
  "item.minecraft.acacia_boat": "dgħajsa tal-akaċja",
  "item.minecraft.dark_oak_boat": "dgħajsa tal-ballut skur",
  "item.minecraft.totem_of_undying": "totem tal-undikazzjoni",
  "item.minecraft.shulker_shell": "qoxra tas-shulker",
  "item.minecraft.iron_nugget": "nugget tal-ħadid",
  "item.minecraft.knowledge_book": "ktieb tal-g ħarfien",
  "item.minecraft.debug_stick": "stikka tal-iddibaggjar",
  "item.minecraft.music_disc_13": "diska tal-mużika□c418 - 13",
  "item.minecraft.music_disc_cat": "diska tal-mużika□c418 - cat",
  "item.minecraft.music_disc_blocks": "diska tal-mużika□c418 - blocks",
  "item.minecraft.music_disc_chirp": "diska tal-mużika□c418 - chirp",
  "item.minecraft.music_disc_far": "diska tal-mużika□c418 - far",
  "item.minecraft.music_disc_mall": "diska tal-mużika□c418 - mall",
  "item.minecraft.music_disc_mellohi": "diska tal-mużika□c418 - mellohi",
  "item.minecraft.music_disc_stal": "diska tal-mużika□c418 - stal",
  "item.minecraft.music_disc_strad": "diska tal-mużika□c418 - strad",
  "item.minecraft.music_disc_ward": "diska tal-mużika□c418 - ward",
  "item.minecraft.music_disc_11": "diska tal-mużika□c418 - 11",
  "item.minecraft.music_disc_wait": "diska tal-mużika□c418 - wait",
  "item.minecraft.music_disc_pigstep": "diska tal-mużika□lena raine - pigstep",
  "item.minecraft.trident": "trident□□meta tkun fl-id prinċipali:□+8ħsara tal-attakk□-2.9veloċità tal-attakk",
  "item.minecraft.phantom_membrane": "membrana tal-phantom",
  "item.minecraft.nautilus_shell": "nautilus shell",
  "item.minecraft.heart_of_the_sea": "il-qalba tal-ba ħar",
  "item.minecraft.crossbow": "crossbow",
  "item.minecraft.suspicious_stew": "stew suspettuż",
  "block.minecraft.loom": "newl tal",
  "item.minecraft.flower_banner_pattern": "disinn tal-istrixxun□ċarġ tal-fjura",
  "item.minecraft.creeper_banner_pattern": "banner pattern□ċarġ creeper",
  "item.minecraft.skull_banner_pattern": "disinn tal-istrixxun□ċarġ tal-kranju",
  "item.minecraft.mojang_banner_pattern": "disinn tal-istrixxun□ħaġa",
  "item.minecraft.globe_banner_pattern": "disinn tal-istrixxun□dinja",
  "item.minecraft.piglin_banner_pattern": "banner pattern□geddum",
  "block.minecraft.composter": "kompożitur",
  "block.minecraft.barrel": "kanna",
  "block.minecraft.smoker": "tpejjep ħafna",
  "block.minecraft.blast_furnace": "forn tal-funderija",
  "block.minecraft.cartography_table": "tabella tal-kartografija",
  "block.minecraft.fletching_table": "fletching table",
  "block.minecraft.grindstone": "ġebla tal-g ħadma",
  "block.minecraft.lectern": "lectern",
  "block.minecraft.smithing_table": "smithing table",
  "block.minecraft.stonecutter": "stonecutter",
  "block.minecraft.bell": "bell",
  "block.minecraft.lantern": "fanal",
  "block.minecraft.soul_lantern": "fanal tar-ruħ",
  "item.minecraft.sweet_berries": "berries ħelu",
  "block.minecraft.campfire": "ħuġġieġa",
  "block.minecraft.soul_campfire": "nar tal-kamp tar-ruħ",
  "block.minecraft.shroomlight": "faqqiegħ li jixgħel",
  "item.minecraft.honeycomb": "xehda",
  "block.minecraft.bee_nest": "bejta tan-na ħal",
  "block.minecraft.beehive": "tad doqqajs",
  "item.minecraft.honey_bottle": "flixkun tal-g ħasel",
  "block.minecraft.honey_block": "blokka tal-g ħasel",
  "block.minecraft.honeycomb_block": "xehda blokk",
  "block.minecraft.lodestone": "ġebla tad-direzzjoni",
  "block.minecraft.netherite_block": "blokk ta 'netherajt",
  "block.minecraft.ancient_debris": "tifrik antik",
  "block.minecraft.target": "mira",
  "block.minecraft.crying_obsidian": "obsidjana tal-biki",
  "block.minecraft.blackstone": "ġebla sewda",
  "block.minecraft.blackstone_slab": "ċangatura tal-ġebla sewda",
  "block.minecraft.blackstone_stairs": "taraġ tal-ġebla sewda",
  "block.minecraft.gilded_blackstone": "ġebla sewda indurata",
  "block.minecraft.polished_blackstone": "ġebla sewda illostrata",
  "block.minecraft.polished_blackstone_slab": "ċangatura tal-ġebla sewda illostrata",
  "block.minecraft.polished_blackstone_stairs": "taraġ tal-ġebla sewda illostrata",
  "block.minecraft.chiseled_polished_blackstone": "ġebla sewda illostrata bid-disinn",
  "block.minecraft.polished_blackstone_bricks": "briksiet tal-ġebla sewda illostrata",
  "block.minecraft.polished_blackstone_brick_slab": "ċangatura tal-ġebla sewda illostrata",
  "block.minecraft.polished_blackstone_brick_stairs": "taraġ tal-briks tal-ġebla sewda illostrata",
  "block.minecraft.cracked_polished_blackstone_bricks": "briksiet tal-ġebla sewda illostrati bil-konsenturi",
  "block.minecraft.respawn_anchor": "ankra mġarrba",
}
export const mt_mt = items; 
